import React from 'react'
import PropTypes from 'prop-types'
import { css } from 'glamor'
import RCSlider, { Range as RCRange } from 'rc-slider'

import { COLORS } from 'config'

const handleStyle = {
  height: 22,
  width: 22,
  borderRadius: '50%',
  backgroundColor: '#f7f7f7',
  border: '1px solid #999999',
  position: 'absolute',
  top: -7,
  marginLeft: -12,
  touchAction: 'none'
}

const trackStyle = {
  height: 10,
  borderRadius: 5,
  backgroundColor: COLORS.blue,
  position: 'absolute',
  top: 0,
  marginLeft: -6,
  paddingRight: 12,
  touchAction: 'none'
}

const Range = ({ name, value, onChange, ...rest }) => {
  const RangeComponent = Array.isArray(value) ? RCRange : RCSlider
  return (
    <RangeComponent
      {...rest}
      value={value}
      onChange={sliderValue =>
        onChange({ target: { name, value: sliderValue } })
      }
      allowCross={false}
      railStyle={{
        height: 10,
        borderRadius: 5,
        backgroundColor: '#e5e5e5',
        marginLeft: -6,
        marginRight: -6
      }}
      trackStyle={Array.isArray(value) ? [trackStyle, trackStyle] : trackStyle}
      handleStyle={
        Array.isArray(value) ? [handleStyle, handleStyle] : handleStyle
      }
      className={css({
        position: 'relative',
        marginLeft: 12,
        marginRight: 12,
        marginTop: 24,
        marginBottom: 12
      }).toString()}
    />
  )
}

Range.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.number
  ]).isRequired,
  onChange: PropTypes.func,
  onChangeEnd: PropTypes.func
}

Range.defaultProps = {
  onChange: () => {},
  onChangeEnd: () => {}
}

export default Range



// WEBPACK FOOTER //
// ./src/components/settings/Range.js